export class EmptySportShowcaseError extends Error {
    constructor(id: string) {
        super(`Empty sport showcase: ${id}`);
    }
}
